(function () {
  const modal = document.querySelector(".newsletter-modal");
  const form = document.querySelector(".newsletter-modal__form");
  const triggers = document.querySelectorAll('a[href="#newsletter"]');

  if (!modal || !form) return;

  // Move modal to end of body so it's not trapped inside the collapsible footer
  document.body.appendChild(modal);

  const close = document.querySelector(".newsletter-modal__close");
  if (!close) return;

  close.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    modal.classList.remove("active");
  });

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      modal.classList.add("active");
      sessionStorage.setItem("newsletter-modal-seen", "1");
    });
  });

  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      modal.classList.remove("active");
    }
  });

  var isSubscribed = document.cookie.split("; ").some(function (c) { return c.startsWith("newsletter_subscribed="); });

  /*if (modal.hasAttribute("data-auto-open") && !isSubscribed && !sessionStorage.getItem("newsletter-modal-seen")) {
    setTimeout(function () {
      sessionStorage.setItem("newsletter-modal-seen", "1");
      modal.classList.add("active");
    }, 2000);
  }*/

  initEmailForm(form);
})();
